import Section from "../../components/Landing/Section";
import { tourismPolicy2023CapitalSubsidyData } from "../../config/homePageUtils";

const CapitalSubsidySection = ({ language }) => {
  const { heading, table, cards, applyUrl } =
    tourismPolicy2023CapitalSubsidyData;

  return (
    <Section
      id="capital-subsidy"
      title={
        language
          ? "पूंजी सब्सिडी और प्रोत्साहन"
          : "Capital Subsidy & Incentives"
      }
      spaceY4Needed={false}
    >
      {/* Table Section */}
      <div className="mb-10">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">
          {language ? table.title.hi : table.title.en}
        </h3>
        {Array.isArray(table.description) ? (
          <div className="mb-2 space-y-1">
            {table.description.map((line, i) => (
              <p key={i}>{language ? line.hi : line.en}</p>
            ))}
          </div>
        ) : (
          <p className="mb-2">
            {language ? table.description.hi : table.description.en}
          </p>
        )}
        <ul className="list-disc pl-6 mb-4 ml-4">
          {table.points.map((point, idx) => (
            <li key={idx}>{language ? point.hi : point.en}</li>
          ))}
        </ul>
        <div className="overflow-x-auto">
          <table className="min-w-full border text-sm text-left bg-btn">
            <thead>
              <tr>
                <th className="border px-4 py-2 text-white">
                  {language ? "वर्ग" : "Category"}
                </th>
                <th className="border px-4 py-2 text-white">
                  {language ? "नियम" : "Criteria"}
                </th>
                <th className="border px-4 py-2 text-white">
                  {language ? "अधिकतम पूंजी सब्सिडी" : "Max Capital Subsidy"}
                </th>
              </tr>
            </thead>
            <tbody>
              {table.rows.map((row, idx) => (
                <tr key={idx} className="align-top">
                  <td className="border px-4 py-2 text-white font-semibold">
                    {row.category}
                  </td>

                  <td className="border px-4 py-2 text-white">
                    <ul className="list-disc pl-5 space-y-1">
                      {row.criteria.map((item, i) => (
                        <li className="text-white py-1" key={i}>
                          {language ? item.hi : item.en}
                        </li>
                      ))}
                    </ul>
                  </td>

                  <td className="border px-4 py-2 text-white font-semibold">
                    {row.maxSubsidy}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Cards Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {cards.map((card, idx) => (
          <div key={idx} className="border p-4 rounded-lg shadow-sm bg-btn">
            <h4 className="text-xl font-semibold mb-2 text-white">
              {language ? card.title.hi : card.title.en}
            </h4>
            {card.description &&
              card.description.map((desc, i) => (
                <p key={i} className="mb-2 text-sm text-white">
                  {language ? desc.hi : desc.en}
                </p>
              ))}
            {card.list && (
              <ul className="list-disc pl-5 text-sm text-white ml-4">
                {card.list.map((item, i) => (
                  <li key={i} className="text-white">
                    {language ? item.hi : item.en}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
};

export default CapitalSubsidySection;
